import React from 'react';
import clsx from 'clsx';
import {
    MenuItem,
    Menu,
    ClickAwayListener,
} from "@material-ui/core";
import RowElement from '../DataElements/RowElement';
import {
    NameTextField,
} from '../../../styling/Styles'
import RadioMechanism from '../../GeneralComponents/RadioMechanism';

const ButtonComponent = (props) => {

    const {
        anchorEl,
        setAnchorEl,
        deleteComponent,
        handleTextButton,
        hrefChecked,
        handleHrefChecked,
        handleHref,
        targetPageChecked,
        handleTargetPageChecked,
        href,
        target,
        targets,
        textButton,
        method,
        selectMethod,
        selectTarget,
        stateMethod,
        setStateMethod
    } = props;

    
    const Methods = ['GET', 'POST'];
    const [displayContent, setDisplayContent] = React.useState(false); 

    //  This method closes the menu with the available methods options for a component button inside a pop up window of a form
    const closeMenu = () => {
        setStateMethod(false);
        setAnchorEl(null);
    }

    //  This method opens the menu with the available methods options for a component button inside a pop up window of a form
    const changeStateMethod = (event) => {
        setStateMethod(true);
        setAnchorEl(event.currentTarget);
    }

    return(
        <div className={clsx('spacingTopDiv')}>

            <RowElement
                label='Button'
                displayContent={displayContent}
                setDisplayContent={setDisplayContent}
                deleteElement={deleteComponent}
            />
            <div className={clsx('spacingTopDiv', 'spacingLeftDiv','spacingRightDiv')} style={displayContent !== true ? {display: 'none'}: {display: 'inherit'} }>  
                <div className={clsx('spacingTopDiv')}> 
                    Button text:&nbsp;
                    <span style={{marginLeft: '5.4vw'}}>&nbsp;</span>
                    <NameTextField
                        placeholder=' Text button'
                        onInput={(e) =>handleTextButton(e)}
                        value={textButton}
                    />
                    <div 
                        className={clsx('teamSelector', 'spacingTopDiv')} 
                    >
                            <span>Method : &nbsp;
                                <span style={{marginLeft: '6.8vw'}} className ={clsx('teamSelector')} 
                                    onClick={(event) => changeStateMethod(event)}
                                    aria-hidden="true"
                                    >{method}</span> 
                                &nbsp;
                            </span>
                            {stateMethod === false ? 
                                <i className={clsx('fa', 'fa-caret-down', 'fa-caret-down2','teamSelector')}> </i>
                                : 
                                <ClickAwayListener 
                                    onClickAway ={closeMenu}
                                >
                                    <i className={clsx('fa', 'fa-caret-up', 'teamSelector')} />
                                </ClickAwayListener>
                            }
                    </div>
                    <Menu   
                        elevation={0}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        anchorEl={anchorEl}
                        keepMounted
                        open={stateMethod}
                        >
                            {
                                Methods.map((option) => (
                                    <MenuItem 
                                        key={option}
                                        onClick ={() => selectMethod(option)}
                                        > 
                                        {option}
                                    </MenuItem>
                                ))
                            }
                    </Menu>
                    
                    <RadioMechanism
                        hrefChecked = {hrefChecked}
                        handleHrefChecked = {handleHrefChecked}
                        handleHref = {handleHref}
                        href = {href}
                        targetPageChecked = {targetPageChecked}
                        handleTargetPageChecked = {handleTargetPageChecked}
                        target = {target}
                        targets = {targets}
                        selectTarget = {selectTarget}
                        isButtonComponent='true'
                    />
                </div>
                
            </div>
            <hr className={clsx('blueLine','spacingTopDiv')}/>
            
        </div>
    )
    
}

export default ButtonComponent;